import * as React from 'react'
import BaseCombobox, { BaseComboboxProps } from './BaseCombobox'

export type EnumMapComboboxProps<E> = Omit<BaseComboboxProps<E>, 'entities' | 'getEntityLabel'> & {
    values: Map<E, string>
}

export default function EnumMapCombobox<E>(props: EnumMapComboboxProps<E>) {
    return (
        <BaseCombobox<E>
            entities={[...props.values.keys()]}
            getEntityLabel={(entity: E) => props.values.get(entity)}
            getEntityValue={(entity: E) => entity?.toString()}
            {...props}
        />
    )
}
